import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-275e50a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-table-wrapper" }
const _hoisted_2 = { class: "tab-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Batch Set ")
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_tabs, {
        type: "card",
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _ctx.handleTabChange
      }, {
        tabBarExtraContent: _withCtx(() => [
          _createVNode(_component_a_button, { onClick: _ctx.handleBatchSetClick }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: item.key,
              tab: item.desc
            }, null, 8, ["tab"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"])
    ]),
    _createVNode(_component_table_wrapper, { "is-pagination": false }, {
      default: _withCtx((slotProps) => [
        _createVNode(_component_a_table, {
          scroll: { y: slotProps.tableHeight },
          dataSource: _ctx.tabs[_ctx.activeKey] ? _ctx.tabs[_ctx.activeKey].data : [],
          columns: _ctx.column,
          rowKey: "id",
          pagination: false,
          rowSelection: _ctx.tableSelection
        }, {
          link: _withCtx(({ record }) => [
            _renderSlot(_ctx.$slots, "link", { row: record }, undefined, true)
          ]),
          operation: _withCtx(({ record }) => [
            _createElementVNode("span", {
              class: "link",
              onClick: ($event: any) => (_ctx.handleSetClick(record))
            }, "Set", 8, _hoisted_4)
          ]),
          _: 2
        }, 1032, ["scroll", "dataSource", "columns", "rowSelection"])
      ]),
      _: 3
    })
  ]))
}